export enum QueryKey {
  getAffiliates = 'getAffiliates',
  exportAffiliates = 'exportAffiliates',
  changeAffiliateCommission = 'changeAffiliateCommission',
}
